export const wpApiUrl = 'http://cms-admin.i3design.jp/wp-json'
// export const wpApiUrl = 'https://cms-admin.i3design.jp/wp-json'
// export const wpApiUrl = 'https://i3design.preview-ysinc.work/wp-json'
export const cmsAdminApiUrl = 'https://cms-admin.i3design.jp/wp-json'
export const inpocketApiUrl = 'https://www.i3design.jp/in-pocket/wp-json'

export const DEFAULT_OGP_IMAGE = 'https://www.i3design.jp/ogp_logo.png'
const CMS_UPLOADS_ORIGIN = 'https://cms-admin.i3design.jp/wp-content/uploads'
const SITE_ORIGIN = 'https://www.i3design.jp'

// WP カテゴリ ID: 1 = pressrelease, 2 = news, 3 = events
const TOPICS_CANONICAL_CATEGORY_ORDER: { id: number; slug: 'pressrelease' | 'events' | 'news' }[] = [
  { id: 1, slug: 'pressrelease' },
  { id: 3, slug: 'events' },
  { id: 2, slug: 'news' },
]

/**
 * 同一記事が複数カテゴリに属する場合の canonical。
 * 優先順: pressrelease > events > news
 */
export const getTopicsCanonicalUrl = (
  postId: number,
  categories: number[] | undefined,
  fallbackSlug: 'pressrelease' | 'events' | 'news',
): string => {
  const cats = categories || []
  const match = TOPICS_CANONICAL_CATEGORY_ORDER.find((item) => cats.indexOf(item.id) !== -1)
  const slug = match ? match.slug : fallbackSlug
  return `${SITE_ORIGIN}/${slug}/${postId}/`
}

/**
 * Topics 詳細の OGP 画像（一覧サムネイル thumbnail_img）
 * 無い場合はデフォルト OGP
 */
export const getTopicsOgImage = (thumbnailImg?: string): string => {
  if (!thumbnailImg) {
    return DEFAULT_OGP_IMAGE
  }

  const path = thumbnailImg.split(CMS_UPLOADS_ORIGIN).join('/images/wp')

  if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0) {
    return path
  }

  return `${SITE_ORIGIN}${path}`
}
